import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useEffect } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsAppShellAdminAreaEnabled } from "@/react/hooks/useIsAppShellAdminAreaEnabled";
import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import { LinkItem } from "./LinkItem";
import { useCollapsedSidebarLinksV3 } from "./useCollapsedSidebarLinksV3";

export const CollapsedSidebar = () => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const settingsNavLinksV3 = useCollapsedSidebarLinksV3();
  const isAppShellAdminAreaEnabled = useIsAppShellAdminAreaEnabled();
  const { totalUnreadPausedAiChatsCount, fetchPausedAiUnreadChatsCount } =
    useCommunityInboxStore();

  // API to fetch unread chats count
  useEffect(() => {
    void fetchPausedAiUnreadChatsCount();
  }, [fetchPausedAiUnreadChatsCount]);

  return (
    <OverlayScrollbarsComponent
      className={classNames("w-16", {
        "h-[calc(100vh-64px)] border-r border-r-primary":
          !isAppShellAdminAreaEnabled,
        "h-full": isAppShellAdminAreaEnabled,
      })}
      options={{
        scrollbars: {
          autoHide: "leave",
          autoHideDelay: 0,
        },
      }}
    >
      <div
        className={classNames(
          "flex h-full flex-col justify-start space-y-2 p-3",
          isMemberAreaAppShellEnabled ? "items-stretch" : "items-center",
          !isMemberAreaAppShellEnabled && "bg-primary",
        )}
      >
        {settingsNavLinksV3.map(({ pathKey, label, path, icon, enabled }) => {
          if (!enabled) return null;
          const isCommunityInboxPage = pathKey === "community_inbox";
          return (
            <LinkItem
              key={label}
              pathKey={pathKey}
              label={label}
              path={path}
              icon={icon}
              shouldShowUnreadCount={
                isCommunityInboxPage && totalUnreadPausedAiChatsCount > 0
              }
              unreadCount={totalUnreadPausedAiChatsCount}
            />
          );
        })}
      </div>
    </OverlayScrollbarsComponent>
  );
};
